export default __webpack_public_path__ + "static/full_bg-0e8dd86303c51d6904bde5ea834c5e6c.jpg";